export default "__VITE_ASSET__sqIvDlbN__"